import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { StorageService } from '../services/storage.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const storage = inject(StorageService);

  const hash = storage.getHash();
  let modifiedReq = req;

  if (hash && !req.params.has('hash')) {
    modifiedReq = req.clone({
      setParams: { hash }
    });
  }

  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        router.navigate(['/error'], {
          queryParams: { type: '403' }
        });
      } else if (error.status === 401 || error.status === 404) {
        router.navigate(['/error'], {
          queryParams: { type: '404' }
        });
      }

      return throwError(() => error);
    })
  );
};
